import { Col, Row, Space, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import StatusIcon from "../../assets/icons/status-circle-black.svg";
import { CREATOR, FAN, HELLO_MESSAGE, MESSAGE_TIME_FORMAT } from "../../helpers/constant";
import { IMessage } from "../../helpers/types";
import "./index.less";
import dateUtil from "../../utls/DateUtil";
import dayjs from "dayjs";

type props = {
  message: IMessage;
  userRole?: string;
};

const MessageTextItemComponent: React.FC<props> = ({ message, userRole }) => {
  const { t } = useTranslation();
  const messageTime = dayjs(message.createdAt);
  return (
    <>
      <div className="messageTextItem">
        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                width: "100%",
              }}
            >
              <Typography.Text className="font-16-regular text-black-color">{message.text}</Typography.Text>

              {messageTime && userRole === CREATOR && (
                <Typography.Text className={`message-time ${message.text && message.text?.length <= 50 ? "message-time-margin" : ""}`} style={{ marginLeft: "auto", paddingLeft:"8px"}}>
                  {messageTime.format(MESSAGE_TIME_FORMAT)}
                </Typography.Text>
              )}
            </div>
          </Col>
        </Row>
        {message.text !== HELLO_MESSAGE && userRole === FAN && (
          <Row className="mt-10">
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Col>
                <img src={StatusIcon} alt={message.status} />
                <Typography.Text className="font-14-bold text-black-color pl-4">{t(message.status!)}</Typography.Text>
              </Col>
              <Col>
                {messageTime && (
                  <Typography.Text className="message-time text-black-color">{messageTime.format(MESSAGE_TIME_FORMAT)}</Typography.Text>
                )}
              </Col>
            </Space>
          </Row>
        )}
      </div>
    </>
  );
};

export default MessageTextItemComponent;
